import './MainLayout.scss';
import Navbar from "../../components/navbar/Navbar"
import { matchPath, Outlet, useLocation } from 'react-router-dom';
import Sidebar from '../../components/sidebar/Sidebar';
import { ROUTES } from '../../config/routes';
import classNames from 'classnames';
import VersionInsights from '../../components/version-insights/VersionInsights';


function MainLayout() {
  const { pathname } = useLocation()
  const activeRoute = matchPath(ROUTES.HOME, pathname)

  return (
    <main className={classNames('MainLayout relative overflow-hidden flex flex-column', { IsInternalNavigationActive: !activeRoute })}>
      <div className="Ellipse1 absolute top-0 left-0" />
      <div className="Ellipse2 absolute top-0 left-50" />
      <div className="Ellipse3 absolute top-0 left-50" />
      <div className="Ellipse4 absolute bottom-0 right-0" />
      <Navbar />
      {/* Replace with actual component which will be fixed position internally */}
      <div className="SidebarContainer flex justify-content-center align-items-center py-2">
        <Sidebar />
      </div>
      <section className='Content pt-2 flex-grow-1  px-4 flex flex-column'>
        <div className="flex-grow-1">
          <Outlet />
        </div>
        <div className="col-12 col-fixed align-items-center justify-content-center">
          <VersionInsights />
        </div>
      </section>
    </main>
  )
}

export default MainLayout